<app-confirm-pop-up-skeleton>
    <div content>
        Your rating preference for this portfolio will be changed. Loans for any remaining amount in this portfolio will
        be picked based on these new rating preferences:
        <app-selected-preferences [preferredCategories]="popUpData.preferredCategories"></app-selected-preferences>
        Please note, loans already found in this portfolio will not be affected by this change.
    </div>
</app-confirm-pop-up-skeleton>